theme.SlideShow=function(e){if(e&&e.dataset&&e.dataset.rpMobileNative==="true"&&window.matchMedia&&window.matchMedia("(max-width: 749px)").matches)return;let sliderWrapper=e.querySelector(".hero__slider--activation"),slideLoop=e.dataset.slideLoop,slideAutoplay=e.dataset.slideAutoplay,autoplayDuration=e.dataset.autoplayDuration,slideLoopValue=!0,autoplay=!1,slideNavPrev=e.querySelector(".swiper-button-prev"),slideNavNext=e.querySelector(".swiper-button-next"),sliderPagination=e.querySelector(".swiper-pagination"),slideShowSpace=parseInt(e.dataset.slideshow)?parseInt(e.dataset.slideshow):0,sliderPerView=parseInt(e.dataset.slidesperview)?parseInt(e.dataset.slidesperview):1,smallDesktop=parseInt(e.dataset.samlldesktopview)?parseInt(e.dataset.samlldesktopview):1,tabletShow=parseInt(e.dataset.showTablet)?parseInt(e.dataset.showTablet):1,mobileShow=parseInt(e.dataset.showMobile)?parseInt(e.dataset.showMobile):1;"false"==slideLoop&&(slideLoopValue=!1),"true"==slideAutoplay&&(parseInt(autoplayDuration),autoplay={delay:autoplayDuration,disableOnInteraction:!1});var rpAuto=/__(1648567878d203fc7a|collection_list_BNhFBD)$/.test(e.id)&&e.dataset.slideAutoplay==="true"&&sliderWrapper&&sliderWrapper.querySelectorAll(".swiper-slide").length>mobileShow;var rpReduced=window.matchMedia("(prefers-reduced-motion: reduce)");var rpVisible=false;if(rpAuto)autoplay={enabled:true,delay:Math.max(3000,parseInt(autoplayDuration)||3000),disableOnInteraction:false};var rpSlider=new Swiper(sliderWrapper,{slidesPerView:mobileShow,autoplay,loop:rpAuto?true:slideLoopValue,clickable:!0,speed:500,spaceBetween:slideShowSpace,pagination:{el:sliderPagination,clickable:!0},navigation:{nextEl:slideNavNext,prevEl:slideNavPrev},breakpoints:{640:{slidesPerView:mobileShow},768:{slidesPerView:tabletShow},1024:{slidesPerView:smallDesktop},1400:{slidesPerView:sliderPerView}}});if(rpAuto){
  // Keep the existing Swiper carousel. Only the first two homepage collection
  // rows auto-advance, and only while visible and when motion is permitted.
  rpSlider.autoplay.stop();
  var rpObserver=null,rpHover=false;
  function rpSync(){
    var active=rpVisible&&!rpReduced.matches&&!document.hidden&&!rpHover;
    if(active){
      if(!rpSlider.autoplay.running)rpSlider.autoplay.start();
    }else if(rpSlider.autoplay.running){
      rpSlider.autoplay.stop();
    }
  }
  function rpEnter(){rpHover=true;rpSync();}
  function rpLeave(){rpHover=false;rpSync();}
  function rpMotionListener(){
    if(rpReduced.addEventListener)rpReduced.addEventListener("change",rpSync);
    else if(rpReduced.addListener)rpReduced.addListener(rpSync);
  }
  rpMotionListener();
  document.addEventListener("visibilitychange",rpSync);
  if(rpSlider.el){
    rpSlider.el.addEventListener("mouseenter",rpEnter);
    rpSlider.el.addEventListener("mouseleave",rpLeave);
  }
  if("IntersectionObserver" in window){
    rpObserver=new IntersectionObserver(function(entries){
      rpVisible=entries.some(function(entry){return entry.isIntersecting;});
      rpSync();
    },{threshold:0.15});
    rpObserver.observe(sliderWrapper);
  }else{
    rpVisible=true;
    rpSync();
  }
  this.onUnload=function(){
    if(rpObserver)rpObserver.disconnect();
    document.removeEventListener("visibilitychange",rpSync);
    if(rpReduced.removeEventListener)rpReduced.removeEventListener("change",rpSync);
    else if(rpReduced.removeListener)rpReduced.removeListener(rpSync);
    if(rpSlider.el){
      rpSlider.el.removeEventListener("mouseenter",rpEnter);
      rpSlider.el.removeEventListener("mouseleave",rpLeave);
    }
    if(!rpSlider.destroyed)rpSlider.destroy(true,true);
  };
}};